export type ChatContextTelemetryEvent = {
  name: 'chat_context_applied' | 'chat_context_apply_failed';
  identity_mode: 'authenticated' | 'iok_user_zendesk_anonymous' | 'public_anonymous';
  keys: string[];
  error?: 'sdk-error' | 'timeout' | 'unknown';
};

export type ChatContextTelemetrySink = (event: ChatContextTelemetryEvent) => void;

let telemetrySink: ChatContextTelemetrySink | undefined;

export const emitChatContextTelemetry = (event: ChatContextTelemetryEvent): void => {
  try {
    telemetrySink?.(event);
  } catch {
    // Context telemetry is best-effort and never affects Chat.
  }
};

export const setChatContextTelemetrySink = (
  sink?: ChatContextTelemetrySink
): (() => void) => {
  telemetrySink = sink;
  return () => {
    if (telemetrySink === sink) telemetrySink = undefined;
  };
};
